import React, { useState, useEffect } from "react";
import {resourcesActions, useSelector} from "inbooma-api";
import { Biscuit} from "../../../../utils";
import t from '../../../helpers/t';
import MicroWidget from '../../../components/MicroWidget';


const WidgetAvailables = (props) => {

    const [initialized,setInitialized] = useState(typeof props.initialized !== 'undefined'?props.initialized:false);
    const _resources = useSelector(state => state.resources_data.getResources);

    const [resourcesCounts,setResourcesCounts] = useState({
        'all' : 0,
        'available' : 0,
    });

    const [resourcesStatus,setResourcesStatus] = useState({
        'all' : 'init',
        'available' : 'init',
    });

    useEffect(() => {

        if (_resources.success === "") return;
    
        if (_resources.success === true) {
            // update status and counts
            if (typeof _resources.data !== 'undefined' && _resources.data.length > 0) {
                let counts_clone = {...resourcesCounts};
                if (resourcesStatus.all === 'pending') {
                    counts_clone.all = _resources.pagination.count;
                    setResourcesCounts(counts_clone);
                } else if (resourcesStatus.available === 'pending') {
                    counts_clone.available = _resources.pagination.count;
                    setResourcesCounts(counts_clone);
                }
            }
            if (resourcesStatus.all === 'pending') {
                setResourcesStatus({
                    ...resourcesStatus,
                    all: 'ready'
                });
            }
            if (resourcesStatus.available === 'pending') {
                setResourcesStatus({
                    ...resourcesStatus,
                    available: 'ready'
                });
                setInitialized(true);
                if(typeof props.setInitialized !== 'undefined'){
                    props.setInitialized(true);
                }
            }
        } else {
          console.log("Failed to request resources!");
        }
    },[_resources, resourcesCounts, resourcesStatus]);

    const initialize = () => {

        if (initialized === true) return;

        if (resourcesStatus.all === 'init') {
            let filter =  {
                limit : 1,
                page : 0,
                find : 'short'
            };
            if(typeof props.client_id !== 'undefined'){
                filter.client_id = props.client_id;
            }
            props.dispatch(resourcesActions.getResources({
                token: Biscuit.get('token'),
                filter: filter
            }));

            let clone = {...resourcesStatus};
            clone.all = 'pending';
            setResourcesStatus(clone);
            return;
        }

        if (resourcesStatus.all === 'ready' && resourcesStatus.available === 'init') {
            let filter = {
                limit : 1,
                page : 0,
                status : 'active',
                find : '!CheckedIn'
            }
            if(typeof props.client_id !== 'undefined'){
                filter.client_id = props.client_id;
            }
            props.dispatch(resourcesActions.getResources({
                token: Biscuit.get('token'),
                filter: filter
            }));

            let clone = {...resourcesStatus};
            clone.available = 'pending';
            setResourcesStatus(clone);
            return;
        }
    };

    initialize();

    return(
        <>
        <MicroWidget
            position={props.position}
            icon="inb-fi-bike"
            title={t('available')}
            value={resourcesCounts.available + "/" + resourcesCounts.all}/>
        </>
    );
};

export default WidgetAvailables;